import React from 'react';
import { createUseStyles } from 'react-jss';
import ToggleButton from 'react-toggle-button';
import { colors } from '../../config/theme';

const useStyles = createUseStyles({
  toggle: {
    // '& div': {
    //   width: '30px',
    //   '&:first-child': {
    //     width: '30px',
    //     height: '15px'
    //   },
    //   '&:nth-child(2)': {
    //     width: '12px',
    //     height: '12px'
    //   }
    // }
  }
});

const Toggle = ({ value, onChange, disabled }) => {
  const classes = useStyles();
  return (
    <div className={classes.toggle}>
      <ToggleButton
        inactiveLabel="OFF"
        activeLabel="ON"
        value={value}
        colors={{
          active: {
            base: colors.chetwodeBlue
          },
          inactive: {
            base: colors.lightGray
          }
        }}
        onToggle={value => onChange(disabled ? value : !value)}
      />
    </div>
  );
};

export default Toggle;
